import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {ChargedActModel} from '../../../api/entity/chargedAct.model';

@Injectable({ providedIn: 'root' })
export class ChargedActRepository extends AbstractRepositoryV2<ChargedActModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ChargedAct', serviceElementsFactory, injector);
    }
}
